import {
  FormLabel,
  FormControl,
  Textarea,
  Text
} from '@chakra-ui/react';

const FormikTextArea = ({
  formik,
  label,
  name="",
  placeholder,
  labelColor,
  disabled=false,
  disabledStyle,
}) => {
  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={"12px"}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <Textarea
        name={name}
        value={formik && formik.values[name]}
        onChange={formik && formik.handleChange}
        placeholder={placeholder}
        type={"text"}
        bg={"transparent"}
        fontFamily={"PlusJakartaSansRegular"}
        borderRadius={"4px"}
        fontSize={"12px"}
        isDisabled={disabled}
        _disabled={disabledStyle}
        color={"#000000"}
        _placeholder={{ color: "#898989" }}
      />
      <Text
        pos={"absolute"}
        bottom={2}
        right={2}
        color={"grey.300"}
        zIndex={2}
        fontFamily={"PlusJakartaSansRegular"}
        fontSize={8}
        letterSpacing={2}
      >
        {formik && formik.values[name]?.length}/300
      </Text>
      {formik && formik.touched[name] && formik.errors[name] ? (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
        >
          {formik.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
}

export default FormikTextArea